var __TEMP__ = require('./_arrayMap.js');var arrayMap = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseIntersection.js');var baseIntersection = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseRest.js');var baseRest = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_castArrayLikeObject.js');var castArrayLikeObject = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = intersection;
